module.exports = __webpack_public_path__ + "static/media/notificacao-patrocinada-dark.7d88ac39.png";